import { cronosClient } from "@/config/client"
import type { UserEvent, UserEventCategory } from "@/services/api/cronos/user/events/get-all"

export interface Body {
  title: string
  startDate: string
  endDate: string
  category: UserEventCategory
  recurringDays: number[]
}

export interface Payload {
  body: Body
  params: {
    startDate: string
    endDate: string
    timeZone: string
  }
}

interface Response {
  description: UserEvent[]
}

export function create(payload: Payload) {
  const { body, params } = payload
  return cronosClient.post<Response, Body>("/v1/user/events", body, { params })
}
